import React from "react";
import { usePublicLang } from "./PublicLangContext";

export function LangSwitcher() {
  const { lang, setLang } = usePublicLang();
  return (
    <div style={{ display: "flex", gap: 2, background: "var(--pa-accent-soft)", borderRadius: 99, padding: "3px 4px" }}>
      {(["sr", "en"] as const).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          style={{
            padding: "4px 10px",
            borderRadius: 99,
            fontSize: 11,
            fontWeight: 700,
            border: "none",
            cursor: "pointer",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            background: lang === l ? "var(--pa-accent)" : "transparent",
            color: lang === l ? "#fff" : "var(--pa-accent2)",
            transition: "all 0.15s",
          }}
        >
          {l === "sr" ? "SR" : "EN"}
        </button>
      ))}
    </div>
  );
}
